<template>
    <div class="splash" :class="{'fade-out' : splashAnimateOut }">
        <div class="splash-content">
            <ion-row>
                <ion-col size="12" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3" class="pd-0">
                    <div class="logo">
                        <svg-vox-partners-club />
                    </div>
                    <div class="partners">
                        <img :src="require('@/assets/img/partners.jpg')" />
                    </div>
                    <div class="text-center mt-10">
                        <div class="loader-wrapper" style="min-height: 70px"><span class="loader red"></span></div>
                        <p class="mt-0">Ładowanie...</p>
                    </div>
                </ion-col>
            </ion-row>
        </div>
        <div class="splash-footer">
            <span>wolność</span>
            <span class="bullet">&#8226;</span>
            <span>rozwój</span>
            <span class="bullet">&#8226;</span>
            <span>partnerstwo</span>
        </div>
    </div>
</template>

<script>
    import SvgVoxPartnersClub from "../components/svgplus/SvgVoxParntersClub.vue";

    export default {
        name: 'Splash',
        components: { SvgVoxPartnersClub },
        data() {
            return {
                splashAnimateOut: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .splash {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 1;
        transition: opacity 0.3s ease-out;
        background: white;
        z-index: 10000;
        pointer-events: none;
        &.fade-out {
            opacity: 0;
        }

        .splash-content{
            padding: 30px;
            .logo svg{
                width: 100%;
                max-width: 600px;
                height: auto;
            }
            .partners img{
                display: block;
                width: 100%;
                margin-top: 30px;
                max-width: 400px;
            }
        }

        .splash-footer{
            position: fixed;
            left: 0; bottom: 0;
            width: 100%;
            padding: 20px;
            color: white;
            text-align: center;
            background: #E4030B;
            span{
                margin: 0 5px;
                vertical-align: middle;
                &.bullet{
                    font-size: 20px;
                }
            }
        }
    }
</style>